export const parseAnalyzerResultArray = (data) => {
  let value = data
  for (let depth = 0; depth < 5; depth += 1) {
    if (typeof value === 'string') {
      const text = value.replace(/```json/gi, '').replace(/```/g, '').trim()
      if (!text) return []
      try {
        value = JSON.parse(text)
      } catch (parseError) {
        return []
      }
    } else if (Array.isArray(value)) {
      return value.flat(Infinity).filter((item) => item !== null && item !== undefined)
    } else if (value && typeof value === 'object') {
      const next =
        value.result ||
        value.results ||
        value.analyzedData ||
        value.data ||
        value.items ||
        value.icd10
      if (!next) return []
      value = next
    } else {
      return []
    }
  }
  return []
}
